import { NavLink } from 'react-router-dom';
import styled, { gapSize, rem } from 'theme';

export const Navigation = styled('nav')`
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  top: 100%;
  position: absolute;
  z-index: -1;
`;

export const List = styled('ul')`
  list-style-type: none;
  display: block;
  align-items: center;
  padding: 0;
  margin: 0 ${() => gapSize(3)};
  display: flex;
  align-items: center;
`;

export const Item = styled('li')`
  display: inline-block;
  font-size: ${rem(16)};
`;

export const Link = styled(NavLink)`
  display: block;
  color: ${(p) => p.theme.colors.black};

  padding: 0 ${() => gapSize(2)};
  line-height: ${rem(68)};
  color: ${(p) => p.theme.colors.white};

  &.active {
    background-color: ${(p) => p.theme.colors.black};
    color: ${(p) => p.theme.colors.primary};
    font-weight: ${(p) => p.theme.fonts.weights.bold};
  }
`;
